<template>
  <div>
    <img alt="Leadtributor logo" src="../assets/leadtributor-logo-text.png" width="500">

    <v-row justify="center">
      <v-col cols="12">
        <CompletedComponent @toLogin="onToLogin">
          <template v-slot:privacy>
            Mit Ihrer Anmeldung erklären Sie sich mit unseren Allgemeinen Geschäftsbedingungen einverstanden. Bitte
            lesen Sie unsere <a>Datenschutzerklärung</a>, unsere <a>Hinweise zu Cookies</a> und unsere Hinweise zu <a>interessenbasierter
            Werbung</a>.
          </template>
          <a>Passwort vergessen?</a>
          <a>Datenschutz</a>
          <a>AGB</a>
        </CompletedComponent>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CompletedComponent from "@/components/login/CompletedComponent";

export default {
  name: "CompletedView",
  components: {CompletedComponent},
  setup() {
    function onToLogin(){
      console.log('to the login!')
    }
    return {onToLogin}
  }
}
</script>

<style scoped>

</style>
